import React from "react"
import render from "budde_utils/js/render"
import {Redux} from "js_utils"

import {BasePage as Page}
  from "core/js/components/presentation/scaffold/page/base"
import {BaseGrid as Grid}
  from "core/js/components/presentation/scaffold/grid/base"
import {GridBaseColumn as GridColumn}
  from "core/js/components/presentation/scaffold/grid/_column/base"
import {BaseScrollable as Scrollable}
  from "core/js/components/presentation/scaffold/scrollable/base"


import {Box}
  from "core/js/components/presentation/container/box"


// import {Heading}
//   from "core/js/components/presentation/atoms/heading"
import {BaseText as Text}
  from "core/js/components/presentation/atoms/text/base"
import {Link}
  from "core/js/components/presentation/atoms/link"
import {Spacer}
  from "core/js/components/presentation/atoms/spacer"
import {Image}
  from "core/js/components/presentation/atoms/image"
import {Snackbar}
  from "core/js/components/presentation/container/snackbar"

import {Background}
  from "core/js/components/presentation/molecules/background"

import {LoginForm} from "./login_form"
import {RequestPasswordForm} from "./request_password_form"

import "core/assets/images/navbar_logo.svg"


const Layout = (props) => { return (
    <Page className="page--login " >
        <Background
            imageUrl={request.static_url + "core/assets/images/bg_desktop_login.jpg"}
            align="center"
            style={{zIndex: "0"}}
        />
        <Scrollable>
            <Grid flex style={{minHeight: "100%"}}>
                <GridColumn
                    widths={{all: 5}}
                    style={{
                        minWidth: "28rem",
                        maxWidth: "38rem",
                        backgroundColor: "rgba(8,12,18,0.95)",
                    }}
                >
                        {props.children}
                </GridColumn>

                <GridColumn widths={{all: 7}} />
            </Grid>
        </Scrollable>
        <Snackbar style={{zIndex: 200}} />
    </Page>
)}



const Content = Redux.subscribe_component(["scaffold", "login"], (props) => (
    <React.Fragment>
        <Box style={{maxWidth: "27rem"}}>
            <Spacer height={3} />

            <svg width="208" height="35" >
                <use xlinkHref="#navbar_logo" />
            </svg>

            <Spacer height={7} />

            {
                props.url
                ? props.resetting_password
                    ? <RequestPasswordForm url={props.url} />
                    : <LoginForm url={props.url} />
                : null
            }

            <Spacer height={3} />

            <Text type="smallprint" align="center">
                {interpolate(
                  "No account? No problem. Send an email with your full name, publisher name and IPI no. to %s. Please note: This app is for our clients only.",
                  ["inside@buddemusic.de"]
                )}
            </Text>

            <Spacer height={6} />

            <Text color="white">
                {gettext("Download our Budde Music app!")}
            </Text>

            <Spacer height={1.5} />

            <Grid flex>
                <GridColumn>
                    <Image interactive
                        source={request.static_url + "core/assets/images/store_apple.svg"}
                        style={{
                          marginRight: "1rem",
                          borderRadius: "0.5rem",
                        }}
                        onClick={() => window.open("https://itunes.apple.com/de/app/budde-music/id1457187640", "_blank")}
                    />
                </GridColumn>
                <GridColumn>
                    <Image interactive
                        source={request.static_url + "core/assets/images/store_google.svg"}
                        style={{
                          marginLeft: "1rem",
                          borderRadius: "0.5rem",
                        }}
                        onClick={() => window.open("https://play.google.com/store/apps/details?id=com.buddemusic.buddemusic_app", "_blank")}
                    />
                </GridColumn>
            </Grid>

            <Spacer height={6} />

            <Link blank
                size="sm"
                align="center"
                href={props.url? props.url("imprint") : "#"}
                target="_blank"
            >
                {gettext("Legal disclaimer")}
            </Link>

        </Box>
    </React.Fragment>
))


render( <Layout />, <Content /> )





// import React from "react"

// import LoginForm from "./login_form"
// import PasswordResetForm from "./password_reset_form"
// import PasswordResetDone from "./password_reset_done"
// import render from "budde_utils/js/render"
// import {Redux} from "js_utils"
// import {View} from "./view"
// import "fetch-everywhere"


// const Layout = (props) => (
//     <div>
//         <div className="page">
//             <div className="container">
//                 <header className="header-main" />
//                     {props.children}
//             </div>
//         </div>
//     </div>
// )


// const Content = Redux.subscribe_component("focus", (props) => (
//     <div className="login-main">
//         <div className={"login login--inside has--reset__form" + (props.focus == "inside" ? " has--reset__form" : "")}>
//             <div className="login__logo">
//                 <img src={request.static_url + "core/img/buddemusic_inside.svg"} alt={django.gettext("Budde Music")} />
//             </div>
//             {/* <div style={{marginTop: "40px", lineHeight: "20px"}}>
//                 <p>Aufgrund von Wartungsarbeiten ist Buddemusic inside bis voraussichtlich 12.02.2018 nicht erreichbar. Bitte schreibt in dringenden Fällen eine Mail an
//                 &nbsp;<a href="mailto:inside@buddemusic.de">inside@buddemusic.de</a>.</p>
//                 <hr />
//                 <p>Due to maintenance activities, Buddemusic inside will be unavailable until February 12th, 2018. In urgent cases, please write an e-mail to
//                 &nbsp;<a href="mailto:inside@buddemusic.de">inside@buddemusic.de</a>.</p>
//             </div> */}
//             <View form="login">
//                 <LoginForm project="inside" />
//             </View>
//             <View project="inside" form="password_reset">
//                 <PasswordResetForm project="inside" />
//             </View>
//             <View project="inside" form="password_reset_done">
//                 <PasswordResetDone project="inside" />
//             </View>

//         </div>
//     </div>
// ))

// render(
//     <Layout />,
//     <Content />
// )
